import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import signup from './signup';

const rootReducer = combineReducers({
  form: formReducer, // Redux-forms
  routing: routerReducer, // Global Routing,
  [signup.NAME]: signup.reducer
});

export default rootReducer;
